

const ProgressLine = ({ total = 6, active = "3.2" }) => {
  // Convert active sub-step to parent integer step
  const activeStep = parseInt(String(active).split(".")[0], 10);

  return (
    <div className="bg-secondary h-[3px] w-full relative flex items-center justify-between px-0">
      {[...Array(total)].map((_, index) => {
        let bgColor = "bg-white"; // default
        if (index < activeStep - 1) bgColor = "bg-secondary"; // before active
        if (index === activeStep - 1) bgColor = "bg-quaternary"; // active

        return (
          <div
            key={index}
            className={`w-[25px] h-[25px] lg:w-[35px] lg:h-[35px] xl:w-[47px] xl:h-[47px] rounded-full border-[3px] border-gray-400 ${bgColor}`}
          ></div>
        );
      })}
    </div>
  );
};

export default ProgressLine;
